<div class="container">
    <div class="left-section">
        <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
            <div class="breadcrumb-item">
                <div
                    [ngClass]="{'breadcrumb-circle-selected' : activeStep == breadcrumb.value, 'breadcrumb-circle' : activeStep < breadcrumb.value, 'breadcrumb-circle-completed' : activeStep > breadcrumb.value}">
                </div> <!-- Bullet point symbol -->
                <span>{{ breadcrumb.title }}</span>
            </div>
            <!-- Add dash separator if not last item -->
            <span *ngIf="!last" class="breadcrumb-separator"></span>
        </ng-container>

    </div>

    <div class="right-section">
        <div *ngIf="userService?.currentUser?.is_superuser">
            <button *ngIf="importedFilePath == null" class="cancel-button" (click)="cancelImport()">Cancel</button>
            <button *ngIf="importedFilePath != null && activeStep == breadcrumbs[0].value" class="save-button-super-user" (click)="saveMappedHeaders()" [disabled]="isMapping">Save & Close</button>
            <button *ngIf="importedFilePath != null && activeStep == breadcrumbs[1].value" class="save-button-super-user" (click)="saveMappingProgress()">Save & Close</button>
            <button *ngIf="importedFilePath != null && activeStep == breadcrumbs[1].value" class="save-button-super-user" (click)="saveAndMapShows()">Approve & Map</button>
        </div>
        <div *ngIf="userService?.currentUser?.is_superuser == false">
            <button *ngIf="importedFilePath != null && activeStep != breadcrumbs[1].value" class="save-button" (click)="saveImport()">Save & Close</button>
            <button *ngIf="importedFilePath != null && activeStep == breadcrumbs[1].value" class="save-button-super-user" (click)="saveMappingProgress()">Save & Close</button>
            <button *ngIf="activeStep == breadcrumbs[1].value"  class="request-approval-button" (click)="requestApproval()">Request Approval</button>
        </div>
    </div>
</div>